/**
 * Tenant-scoped localStorage wrapper.
 * All keys are prefixed with the tenant subdomain so that
 * two tenants on the same origin can never share auth tokens
 * or other session data.
 *
 * Usage:
 *   import tenantStorage from '../utils/tenantStorage';
 *   tenantStorage.setItem('accessToken', token);
 *   tenantStorage.getItem('accessToken');
 *   tenantStorage.removeItem('accessToken');
 *   tenantStorage.clear();  // removes only this tenant's keys
 */

import { TENANT_SUBDOMAIN } from '../config/appConfig';

const PREFIX = TENANT_SUBDOMAIN ? `rt_${TENANT_SUBDOMAIN}_` : 'rt_default_';

const tenantStorage = {
  getItem(key) {
    return localStorage.getItem(PREFIX + key);
  },

  setItem(key, value) {
    localStorage.setItem(PREFIX + key, value);
  },

  removeItem(key) {
    localStorage.removeItem(PREFIX + key);
  },

  /** Remove all keys belonging to the current tenant only. */
  clear() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  },
};

export default tenantStorage;
